import type { EmployeeModuleKey, PresetPermissions } from './types';
import { EMPLOYEE_PERMISSION_MODULES } from './modules';

export const PRESET_NONE: PresetPermissions = {
  canView: false,
  canEdit: false,
  canVoid: false,
  canDiscount: false,
  canViewOthers: false,
  actions: {},
};

export const PRESET_VIEW: PresetPermissions = {
  canView: true,
  canEdit: false,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {},
};

export const PRESET_EDIT: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {},
};

/** Cobrar sin anular ni descontar (dueño puede activarlos después). */
export const PRESET_POS_SELL: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {},
};

export const PRESET_POS_FULL: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: true,
  canDiscount: true,
  canViewOthers: true,
  actions: {},
};

export const PRESET_POS_EDIT_VOID: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: true,
  canDiscount: false,
  canViewOthers: true,
  actions: {},
};

export const PRESET_CASH_OPERATE: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: false,
  actions: {},
};

export const PRESET_AGENDA_OWN: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canManageAgenda: false,
  canViewOthers: false,
  actions: {},
};

export const PRESET_AGENDA_EDIT_ALL: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canManageAgenda: false,
  canViewOthers: true,
  actions: {},
};

export const PRESET_AGENDA_ADMIN: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canManageAgenda: true,
  canViewOthers: true,
  actions: {},
};

export const PRESET_REPORTS_AUDIT: PresetPermissions = {
  canView: true,
  canEdit: false,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {
    sales: true,
    cash: true,
    expenses: true,
    inventory: true,
    fiado: true,
    margins: true,
    by_employee: true,
    export: true,
  },
};

export const PRESET_KITCHEN_STAFF: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {
    update_status: true,
    view_prices: false,
    view_customer: false,
    manage_stations: false,
  },
};

export const PRESET_TABLES_OPERATE: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: { reopen: false, manage_layout: false },
};

export const PRESET_TABLES_MANAGE: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: { reopen: true, manage_layout: true },
};

export const PRESET_ORDERS_OPERATE: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: {
    accept: true,
    reject: true,
    mark_ready: true,
    mark_delivered: true,
    cancel: false,
    refund: false,
    view_contact: false,
  },
};

export const PRESET_PURCHASES_VIEW: PresetPermissions = {
  canView: true,
  canEdit: false,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: { view_cost: false, receive: false, return: false },
};

export const PRESET_PURCHASES_STOCK_LEAD: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: { receive: true, view_cost: true, export: true },
};

export const PRESET_PURCHASES_SUPERVISOR: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: true,
  canDiscount: false,
  canViewOthers: true,
  actions: { receive: true, view_cost: true, export: true },
};

export const PRESET_PURCHASES_ADMIN: PresetPermissions = {
  canView: true,
  canEdit: true,
  canVoid: true,
  canDiscount: false,
  canViewOthers: true,
  actions: { receive: true, view_cost: true, export: true, return: true },
};

export const PRESET_PURCHASES_AUDIT: PresetPermissions = {
  canView: true,
  canEdit: false,
  canVoid: false,
  canDiscount: false,
  canViewOthers: true,
  actions: { view_cost: true, export: true },
};

export function allNoneExcept(
  overrides: Partial<Record<EmployeeModuleKey, PresetPermissions>>
): Partial<Record<EmployeeModuleKey, PresetPermissions>> {
  const base = Object.fromEntries(
    EMPLOYEE_PERMISSION_MODULES.map((module) => [module, { ...PRESET_NONE }])
  ) as Partial<Record<EmployeeModuleKey, PresetPermissions>>;
  return { ...base, ...overrides };
}
